import { render } from "./ContentDetailKredit.vue?vue&type=template&id=51dd2e11&scoped=true"
import script from "./ContentDetailKredit.vue?vue&type=script&lang=js"
export * from "./ContentDetailKredit.vue?vue&type=script&lang=js"

import "./ContentDetailKredit.vue?vue&type=style&index=0&id=51dd2e11&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51dd2e11"]])

export default __exports__